export default {
	about: 'About',
	about_the_program: 'About the Program',
	acc_score: 'Accumulated score',
	accept: 'Accept',
	activities: 'Activities',
	activity: 'Activity',
	add_a_review: 'Add a review',
	add_image: 'Add imagem',
	address: 'Address',
	address_required: 'Address required',
	all: 'All',
	all_f: 'All',
	an_error_has_occurred: 'An error has occurred',
	an_unexpected_error_has_occurred_try_again: 'An unexpected error has occurred. Try again.',
	and: 'and',
	answer: 'Answer',
	answer_plural: 'Answers',
	answer_reported_successfully: 'Answer reported successfully',
	answered: 'Answered',
	apply: 'Apply',
	approved: 'Approved',
	areas: 'Areas',
	at: 'at',
	attention: 'Attention',
	audio: 'Audio',
	available_in: 'Available in',
	back: 'Back',
	back_to_training: 'Back to training',
	badge: 'Badge | Badges',
	badges: 'Badges',
	before_starting_this: ' before starting this',
	bookmarks: 'Bookmarks',
	browser_window_blocked_click: 'Your browser blocked the window, please click',
	by: 'by',
	calendar: 'Calendar',
	campaign: 'Campaign',
	campaigns: 'Campaigns',
	cancel: 'Cancel',
	cant_watch_click_here: 'Click here to watch in full screen',
	categories: 'Categories',
	category: 'Training Area',
	certificate: 'Certificate | Certificates',
	certificates: 'Certificates',
	check_scorm_finished: 'Check activity completion',
	clear_date: 'Clear Date',
	clear_filters: 'Clear Filters',
	clear_notifications: 'Clear notifications',
	click_here: 'Click here',
	close: 'Close',
	code: 'Code',
	code_a_z: 'Code A-Z',
	compressed_file: 'Compressed File',
	confirm: 'Confirm',
	confirm_report_answer: 'Confirm answer report',
	confirm_report_topic: 'Confirm topic report',
	confirm_reporting_this_answer_this_should_be_done_only_with_answers_that_do_not_follow_the_rules_of_the_platform_a_message_will_be_sent_to_moderators:
		'Confirm reporting this answer? This should be done only with asnwers that do not follow the rules of the platform. A message will be sent to moderators',
	confirm_reporting_this_topic_this_should_be_done_only_with_topics_that_do_not_follow_the_rules_of_the_platform_a_message_will_be_sent_to_moderators:
		'Confirm reporting this topic? This should be done only with topics that do not follow the rules of the platform. A message will be sent to moderators',
	contact_us: 'Contact us',
	content: 'Content',
	content_deadline: 'Deadline for content access',
	cookies_custom: 'Custom cookies',
	cookies_custom_information:
		'When you access this platform, cookies and certain data related to your device may be collected so that we can provide to you a personalized contents and trainings.',
	cookies_fonctionnels: 'Functional cookies',
	cookies_fonctionnels_information:
		'They are used to recognize you when you access the platform, to save your configuration preferences and protect your user account. They cannot be deactivated because they are essential for the platform to work properly.',
	cookies_policy: 'Cookies Policy',
	cookies_policy_information:
		'This platform uses cookies to ensure most efficient and personalized services. By accepting, you agree to their use.',
	cookies_settings: 'Cookies Settings',
	copyright: 'Copyright',
	correct: 'Correct',
	country_of_residence: 'Country of Residence',
	country_you_want_to_access: 'Country you want to access',
	course: 'Course',
	course_price: 'Price',
	creation_date: 'Creation date',
	creator: 'Creator',
	crop: 'Crop',
	crop_image: 'Crop image',
	date: 'Date',
	description: 'Description',
	divorced: 'Divorced',
	document: 'Document',
	done: 'Done',
	doubts_about_training: 'Doubts about the training',
	download: 'Download',
	share: 'Share',
	download_app: 'Download app',
	download_our_app: 'Download our app',
	download_our_app_information:
		"Do you know our app? Enjoy our content from your iPhone or Android. Download it now, it's free!",
	downloading_content: 'Downloading content',
	downloads: 'Downloads',
	duration: 'Duration',
	earn_points: 'Earn Points',
	earned: 'Earned',
	earning_points: 'Earning points',
	email: 'E-mail',
	enter: 'Enter',
	error_loading_data: 'There was an error loading the information. Try again later.',
	events: 'My Events',
	excel_file: 'Excel File',
	extensions: 'Extensions',
	faq: 'FAQ',
	favorite_course: 'Favorite Course',
	favorite_trail: 'Favorite Trail',
	featured_rewards: 'Featured Rewards',
	file: 'File',
	file_download_failed: 'File download failed',
	file_download_finished: 'File download finished',
	file_download_started: 'File download started',
	filters: 'Filters',
	filter_category: 'Filter by category',
	filter_sort_by: 'Sort by',
	finished: 'Finished',
	first_access: 'First Access',
	follower: 'Follower',
	free: 'free',
	frequently_asked_questions: 'Frequently Asked Questions',
	full_name: 'Full name',
	go_to_class: 'Go to class',
	groups: 'Groups',
	have_any_doubt_sugestion_comment_or_compliment_about_the_intel_rewards_you_program_send_us_a_message:
		'If you have any questions, comments or suggestions about Intel Rewards You program, feel free to send us a message.',
	headquarter: 'Chain / Company',
	headquarters: 'Chains / Companies',
	help: 'Help',
	helper_new_password: 'Your password must contain at least 8 characters',
	helper_password_low: 'Your password must be at least 6 characters',
	helper_password_medium:
		'Your password must contain at least 6 characters, uppercase letters, lowercase letters, numbers (! @ # $% ˆ)',
	helper_password_strong:
		'Your password must contain at least 6 characters, uppercase letters, lowercase letters, numbers and symbols (! @ # $% ˆ)',
	here: 'here',
	home: 'Home',
	hour: 'hour',
	hour_plural: 'hours',
	how_do_you_rate_this_training: 'How to you rate this training?',
	image: 'Image',
	image_from_device: 'Image from device',
	image_from_url: 'Image from address',
	image_size: 'Image Size',
	image_url: 'Image address',
	in_progress: 'In progress',
	influencer: 'Influencer',
	insert_sales: 'Insert Sales',
	instructors: 'Team',
	intel_lovers: 'Intel Lovers',
	introduction: 'Introduction',
	invalid_document: 'Invalid document',
	invited: 'Invited',
	items_per_page: 'items per page',
	itp_points: 'Intel Rewards You Points',
	joined_the_class: 'joined the class',
	keep_watching: 'Keep watching',
	know_more: 'About',
	language: 'Language',
	last: 'Last',
	last_name: 'Last Name',
	legal_information: 'Legal Information',
	lets_talk_about_privacy: "Let's talk about privacy!",
	level: 'Level',
	library: 'Library',
	like: 'Like',
	liked: 'Liked',
	likes: 'Likes',
	live_class: 'Live Class',
	live_classes: 'Live Classes',
	loading_data: 'Loading data',
	loading_news: 'Loading news',
	make_sure_all_mandatory_fields_are_completed: 'Make sure all mandatory fields are completed',
	make_sure_that_all_fields_are_filled_in: 'Make sure that all fields are filled in',
	married: 'Married',
	meet_the_team: 'Meet the Team',
	message: 'Message',
	message_sent_successfully: 'Message sent successfully',
	minute: 'minute',
	minute_plural: 'minutes',
	name: 'Name',
	new_certificate_in_course: 'New certificate in the course {title}',
	new_certificate_in_trail: 'New certificate in the trail {title}',
	new_download_code: 'New download code',
	news: 'News',
	next_activity: 'Next activity',
	no: 'No',
	no_data_avaliable: 'No data avaliable',
	no_news_are_available_at_the_moment: 'No news available at the moment.',
	no_news_are_available_with_the_selected_filter: 'No news available for the selected filter',
	no_pre_visualization_available: 'No pre visualization available',
	no_results: 'No results',
	no_results_found: 'No results found',
	no_vacancy: 'No vacancy',
	not_allowed_or_page_not_found: 'Not found or not allowed.',
	not_answered: 'Not answered',
	not_answered_f: 'Not answered',
	notification: 'Notification',
	notifications: 'Notifications',
	number_required: 'Number required',
	neighborhood_required: 'Neighborhood required',
	state_required: 'State required',
	city_required: 'City required',
	zip_code_required: 'ZIP code required',
	complete_your_registration: 'Complete your registration',
	select_your_profile: 'Select your profile',
	fill_in_later: 'Fill in later',
	document_required: 'Document is required',
	document_already_registered: 'Document is already registered',
	no_registered_profile: 'No registered profile. Check with the platform manager to correctly release authentication.',
	login_with_google: 'Login with google',
	error_signing_in_with_google: 'Error signing in with Google, please try again later.',
	birthday_must_be_before_today: 'Fill in the field correctly',
	please_fill_out_the_form_correctly: 'Please fill out the form correctly.',
	your_accounts_has_been_completed_successfully: 'Your account has been completed successfully',
	register_not_unique: 'Register not unique',
	of: 'of',
	online_courses: 'Online Courses',
	only_available_when_finished_training: 'Available only when you finish the training',
	order_by: 'Order by',
	origin: 'Origin',
	password: 'Password',
	pdf_file: 'PDF File',
	percentage: 'Percentage',
	place: 'Place',
	platform_meta_description: 'Powered by Take 5 LMS',
	please_wait_activities_loading: 'Loading activities, please wait...',
	podcasts: 'Podcasts',
	point: 'Point',
	point_plural: 'Points',
	points: 'Points',
	points_earned: 'Earned Points',
	points_table: 'Score Table',
	pontuation: 'Punctuation',
	post_a_comment: 'Post a comment',
	powerpoint_file: 'PowerPoing File',
	presential: 'Face-to-Face',
	presential_courses: 'Face-to-Face Courses',
	privacy_policy: 'Privacy Policy',
	price: 'Price',
	profile: 'Profile',
	progress: 'Progress',
	ranking: 'Ranking',
	reaction_evaluation: 'Reaction Evaluation',
	received_a_certificate_in_course: '{name} received a certificate in the course {title}',
	received_a_certificate_in_trail: '{name} received a certificate in the trail {title}',
	redemption_code: 'Redemption code',
	refuse: 'Refuse',
	regionals: 'Subsidiaries',
	registered: 'Registered',
	reproved: 'Reproved',
	requirement: 'Requirement',
	response_sent_successfully: 'Response sent successfully',
	result_found: 'result found | results found',
	retry_test: 'Try again',
	return_to_activities: 'Return to activities',
	reviews: 'Reviews',
	reward_store: 'Rewards Store',
	reward_redemption: 'Reward redemption',
	rewards_you: 'Rewards You',
	rotate_device_for_better_experience: 'Flip your device for better experience!',
	save: 'Save',
	save_data_success: 'Data saved successfully!',
	score: 'Score',
	score_statement: 'Score Statement',
	scorm_finished: 'Activity finished',
	scorm_not_finished: 'Activity not finished',
	search: 'Search',
	search_for_your_address: 'Search for your address',
	search_for_zip_address_or_city: 'Search by your ZIP code, address, or city',
	see_all_content: 'See all content',
	see_more: 'See more',
	select_a_file: 'Select a file',
	select_a_image: 'Select an image',
	selected_campaign: 'Selected Campaign',
	seller_cant_find_your_store: "Seller, can't find your store?",
	seller_hint:
		'Busque su tienda simplemente escribiendo el número de registro de la empresa (sin utilizar puntos, guiones o barras).',
	send: 'Send',
	set_cookies: 'Set cookies',
	show_certificate: 'View certificate',
	single: 'Single',
	size: 'Size',
	start_reaction_assessment: 'Start Reaction Assessment',
	status: 'Status',
	support: 'Support',
	tags: 'Highlights',
	take_course: 'Start Course',
	terms_and_conditions: 'Terms and Conditions',
	test: 'Test',
	there_are_no_codes_available:
		'There are no codes available to release an app on the App Store. Please contact the support team.',
	this_content_will_be_available_on: 'This content will be available on',
	this_website_is_best_viewed_in_google_chrome_and_mozilla_firefox:
		'This website is best viewed in Google Chrome and Mozilla Firefox',
	timezone: 'Timezone',
	title: 'Title',
	title_a_z: 'Title A-Z',
	to_access_the_class: 'to access the class',
	to_do: 'To-do',
	to_understand_why_we_use_cookies: 'For more information click here.',
	total_results: 'Total results',
	topic_reported_successfully: 'Topic reported successfully',
	trail: 'Trail',
	trail_plural: 'Trails',
	trails: 'Trails',
	training: 'Training',
	training_plural: 'Trainings',
	type: 'Type',
	type_to_search: 'Type to search',
	unfavorite_course: 'Unfavorite Course',
	unfavorite_trail: 'Unfavorite Trail',
	unlike: 'Dislike',
	upload_photos: 'Photo Upload',
	user: 'User',
	user_environment: 'User environment',
	vimeo: 'Vimeo',
	we_were_unable_to_send_your_message_please_try_again_later:
		'We were unable to send your message, please try again later',
	webcast: 'Webinar',
	webcasts: 'Webinars',
	webinar: 'Webinar',
	webinars: 'Webinars',
	widowed: 'Widowed',
	window_blocked: 'Window blocked',
	workload: 'Workload',
	wowza: 'Wowza',
	yes: 'Yes',
	you_already_reviewed: 'You have already added your review',
	you_must_complete_all_required_training_before_redeeming:
		'You must complete all required training before redeeming',
	you_must_finish_the_test: 'Please complete the test',
	you_need_to_end_the_training_before_you_can_respond_to_the_reaction_assessment:
		'You need to end the training before you can respond to the reaction assessment',
	you_need_to_finish_the_content: 'You need to finalize the content ',
	your_answer: 'Your answer',
	your_rating: 'Your rating',
	your_text_is_longer_than_256_characters: 'Your text is longer than 256 characters',
	youtube: 'YouTube',
	zip_code: 'Zip code',
	oldest: 'Oldest',
	correct_answer: 'Correct answer',
	incorrect_answer: 'Incorrect answer',
	drills: 'Drills',
	badge_title_shared: 'Check out the new badge I won',
	badge_title_earned: "Congratulations, you've earned a new badge!",
	badge_button_text_claim: 'Claim badge',
	challenge_of_the_day: 'Challenge of the day',
	recall_and_test_your_knowledge_with_quick_questions: 'Recall and test your knowledge with {count} quick question | Recall and test your knowledge with {count} quick questions',
	correct_answer: 'Correct answer',
	incorrect_answer: 'Incorrect answer',
	can_you_answer_this_question: 'can you answer this question?',
	unavailable: "Unavailable",
	you_already_have_a_certificate_in_one_event_on_this_catalog: "You are already enrolled or have a certificate in an event from this catalog {catalog}.",
	no_category: 'No category',
	search_by_ia: 'Search for AI',
	no_access_to_send_points: "Unfortunately, you do not have permission to send points. Please contact the platform administrator.",
	please_log_in_to_the_platform_first: "To download the app, please log in to the platform first",
	required_update_title: 'Required Update',
	required_update_message_ios: 'A new version of the app is available with essential improvements. To continue, please update manually by following these steps:<br><br><b>1.</b> Open the <b>App Store</b> app.<br><b>2.</b> Tap your profile icon (top right corner).<br><b>3.</b> Scroll down to the pending updates section and tap <b>Update</b> next to our app.',
	required_update_message_android: 'A new version of the app is available with essential improvements. To continue using the platform, click the button below to be redirected to the app store and complete the update automatically.',
	required_update_button_android: 'Update'
}
